import React from 'react';
import {connect} from 'react-redux';

import {BaseRate, mapStateToProps} from './BaseRate.jsx';

import {addCouponRate as addCouponRateAction, addRate as addRateAction} from 'actions/creators/CouponRate';
import {makeBet as makeBetAction} from 'actions/creators/MakeBet';
import {requestBetTypes as requestBetTypesAction} from 'actions/creators/HistoryBet';

import {getRateDisplayValue} from 'rendering-commons';

class TotalRate extends BaseRate {
    constructor(props) {
        super(props);
    }

    render() {
        const {rate, outcomeIsBlocked} = this.props;

        if (rate === undefined) {
            return false;
        }

        const isVisible = rate.get('isVisible');
        const rateValue = isVisible
            ? getRateDisplayValue(rate.get('value'))
            : '';

        let cls = 'out-rate';

        if (rate.get('isBlocked') || outcomeIsBlocked) {
            cls += ' closed';
        }

        return (<span key={rate.get('id')} ref="rate" className={cls} onClick={this._onClick}>{rateValue}</span>);
    }
}

export default connect(mapStateToProps, {
    addCouponRateAction, makeBetAction, requestBetTypesAction, addRateAction
}, null, false)(TotalRate);



// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/components/rates/TotalRate.jsx